import { Box } from '@mui/material';
import { BOTTOM_NAVIGATION_HEIGHT_SPACING } from '../../BottomNavigation/BottomNavigationBar';
import AwarenessCampaignAddressSection from './AwarenessCampaignAddressSection';
import AwarenessCampaignDetailHeader from './AwarenessCampaignDetailHeader';
import ConfirmCompleteCampaignDialog from './ConfirmCompleteCampaignDialog';


const AwarenessCampaignDetailContent: React.FC = () => {
    return (
        <Box
            padding={2}
            pb={BOTTOM_NAVIGATION_HEIGHT_SPACING}
            sx={{ height: '100vh', overflowY: 'auto' }}
            display="flex"
            flexDirection="column"
            gap={3}
        >
            <AwarenessCampaignDetailHeader />

            <AwarenessCampaignAddressSection />
            
            <ConfirmCompleteCampaignDialog />
        </Box>
    );
};

export default AwarenessCampaignDetailContent;
